/* global $ */
import { initGoogleAuth } from './modules/googleAuth';
import { guessTz } from './modules/timezoneGuess';
import { getTemplateJsContext } from './modules/helpers';

const signInButton = document.getElementById('gSignInButton');
const timezoneInput = document.querySelector('[name=timezone]');
const countryInput = document.querySelector('[name=country]');

timezoneInput.value = guessTz();

const templateJsContext = getTemplateJsContext();

countryInput.addEventListener('change', (e) => {
  if (e.target.value === 'US') {
    document.getElementById('us-only').style.display = '';
  } else {
    document.getElementById('us-only').style.display = 'none';
    document.querySelector('[name=us_state]').value = '';
  }
});

initGoogleAuth(templateJsContext.googleClientId, signInButton, templateJsContext.registerTesterWithSsoUrl, () => {
  const extraData = {
    timezone: timezoneInput.value
  };
  if (countryInput.value) {
    extraData.country = countryInput.value;
  }
  return extraData;
});
